export default __webpack_public_path__ + "static/logo-95ff958810cc7f7114fa9216f9895023.svg";